import React, { useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import Dropzone from 'react-dropzone';
import '../css/WPP8M.css';

const WPP8MPage = () => {
    const [selectedFile, setSelectedFile] = useState(null);
    const [fileName, setFileName] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const MAX_FILE_SIZE = 5 * 1024 * 1024;

    const handleFileDrop = (acceptedFiles) => {
        const file = acceptedFiles[0];
        if (file.size > MAX_FILE_SIZE) {
            Swal.fire({
                icon: 'error',
                title: 'Archivo demasiado grande',
                text: 'El archivo seleccionado supera el tamaño máximo permitido de 5 MB.',
            });
        } else {
            setSelectedFile(file);
            setFileName(file.name);
        }
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        setIsSubmitting(true);

        const formData = new FormData(event.target);
        if (selectedFile) {
            formData.append('file', selectedFile);
        }

        const apiUrl = "https://www.darparaganarwpp.com/api";

        axios.post(`${apiUrl}/upload`, formData)
            .then(() => {
                Swal.fire({
                    icon: 'success',
                    title: 'Formulario enviado con éxito',
                    showConfirmButton: false,
                    timer: 1500
                });
                event.target.reset();
                setSelectedFile(null);
                setFileName(null);
            })
            .catch(error => {
                Swal.fire({
                    icon: 'error',
                    title: 'Error enviando el formulario',
                    text: error.message,
                });
                console.error('Error enviando el formulario:', error);
            })
            .finally(() => {
                setIsSubmitting(false);
            });
    };

    const handleLocationClick = (e) => {
        e.preventDefault();
        Swal.fire({
            title: 'Oficinas WPP',
            html: `
                <div style="font-size: 1rem; line-height: 1.6; color: #333;">
                    <p style="margin-bottom: 4px; font-weight: 600;">Pasaje Paseo de las Carretas 2580</p>
                    <p style="margin-bottom: 4px;">Puntas Carretas Tower, Piso 6</p>
                    <p style="margin-bottom: 12px;">Montevideo, 11300</p>
                </div>
            `,
            confirmButtonText: 'Ver en Google Maps',
            confirmButtonColor: '#6d28d9',
            showCloseButton: true,
            preConfirm: () => {
                window.open('https://www.google.com/search?q=Pasaje+Paseo+de+las+Carretas+2580+Puntas+Carretas+Tower+Piso+6+-+Montevideo%2C+11300&oq=Pasaje+Paseo+de+las+Carretas+2580+Puntas+Carretas+Tower+Piso+6+-+Montevideo%2C+11300&gs_lcrp=EgZjaHJvbWUyBggAEEUYOdIBBzQ4MmowajeoAgCwAgA&sourceid=chrome&ie=UTF-8#rlimm=7945891122452888699', '_blank');
            }
        });
    };

    return (
        <div className="wpp8m-page">

            {/* HEADER */}
            <header className="wpp8m-header">
                <a href="https://www.wpp.com" target="_blank" rel="noopener noreferrer" className="wpp8m-header-logo">
                    <img src="https://www.wpp.com/assets/img/WPP-logo.svg" alt="WPP" className="wpp8m-header-logo-img" />
                    <span className="wpp8m-header-logo-text">Mes de la Mujer</span>
                </a>
                <div className="wpp8m-header-badge">
                    <span className="wpp8m-badge-8m">#DarParaGanar</span>
                </div>
            </header>

            {/* MAIN — 50/50 */}
            <main className="wpp8m-main">

                {/* LEFT — IMAGE + TEXT */}
                <div className="wpp8m-left">
                    <div className="wpp8m-left-bg" style={{ backgroundImage: "url('/images/solutions-background.png')" }}></div>
                    <div className="wpp8m-left-overlay"></div>
                    <div className="wpp8m-left-content">
                        <span className="wpp8m-tag">WPP · Uruguay</span>
                        <h1 className="wpp8m-left-title">
                            Dar para<br />
                            <span>ganar.</span><br />
                        </h1>
                        <div className="wpp8m-left-divider"></div>
                        <p className="wpp8m-left-subtitle">
                            En WPP creemos que compartir y dar son las claves para construir la sociedad que soñamos. Ayudarnos y apoyarnos es el camino hacia un futuro más igualitario.  
                            En el marco del mes de la mujer, te invitamos a una mentoría única, donde compartiremos una charla inspiradora y una caminata de mentoría. Será una instancia para conectar, aprender y crecer juntas, en un ambiente de colaboración y apoyo mutuo. 
                            Este espacio está diseñado especialmente para estudiantes de comunicación y marketing, que aún no se encuentren en actividad laboral y que buscan herramientas para su desarrollo profesional y personal. Los cupos son limitados.
                            Juntas podemos construir una sociedad más inclusiva y colaborativa.
                        </p>
                        <div className="wpp8m-event-info">
                            <div className="wpp8m-event-item">
                                <span className="wpp8m-event-icon">📅</span>
                                <div>
                                    <span className="wpp8m-event-label">Fecha</span>
                                    <span className="wpp8m-event-value">Lunes 16 de marzo</span>
                                </div>
                            </div>
                            <div className="wpp8m-event-item">
                                <span className="wpp8m-event-icon">⏰</span>
                                <div>
                                    <span className="wpp8m-event-label">Hora</span>
                                    <span className="wpp8m-event-value">15:00</span>
                                </div>
                            </div>
                            <div className="wpp8m-event-item">
                                <span className="wpp8m-event-icon">📍</span>
                                <div>
                                    <span className="wpp8m-event-label">Lugar</span>
                                    <button 
                                        type="button"
                                        onClick={handleLocationClick}
                                        className="wpp8m-event-value wpp8m-event-link"
                                    >
                                        Oficinas WPP
                                    </button>
                                    <p className="wpp8m-event-address">
                                        Pasaje Paseo de las Carretas 2580<br />
                                        Puntas Carretas Tower, Piso 6
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* RIGHT — FORM */}
                <div className="wpp8m-right">
                    <div className="wpp8m-form-header">
                        <h2 className="wpp8m-form-title">Aplicar</h2>
                    </div>

                    <form className="wpp8m-form" onSubmit={handleSubmit}>

                        {/* Nombre + Apellido */}
                        <div className="wpp8m-form-row">
                            <div className="wpp8m-form-group">
                                <label htmlFor="firstName">Nombre</label>
                                <input type="text" id="firstName" name="firstName" required />
                            </div>
                            <div className="wpp8m-form-group">
                                <label htmlFor="lastName">Apellido</label>
                                <input type="text" id="lastName" name="lastName" required />
                            </div>
                        </div>

                        {/* Email */}
                        <div className="wpp8m-form-group">
                            <label htmlFor="email">Correo Electrónico</label>
                            <input type="email" id="email" name="email" required />
                        </div>

                        {/* Universidad + Carrera */}
                        <div className="wpp8m-form-row">
                            <div className="wpp8m-form-group">
                                <label htmlFor="university">Universidad</label>
                                <input type="text" id="university" name="university" required />
                            </div>
                            <div className="wpp8m-form-group">
                                <label htmlFor="major">Carrera</label>
                                <input type="text" id="major" name="major" required />
                            </div>
                        </div>

                        {/* Motivación */}
                        <div className="wpp8m-form-group">
                            <label htmlFor="motivation">¿Por qué querés ser parte de esta iniciativa?</label>
                            <textarea id="motivation" name="motivation" rows="3" required></textarea>
                        </div>

                        {/* File upload */}
                        <div className="wpp8m-form-group dropzonestyle">
                            <label htmlFor="file">Subir Certificado de Escolaridad (PDF, JPG, PNG)</label>
                            <Dropzone
                                onDrop={handleFileDrop}
                                accept={{
                                    'application/pdf': ['.pdf'],
                                    'image/jpeg': ['.jpg', '.jpeg'],
                                    'image/png': ['.png']
                                }}
                            >
                                {({ getRootProps, getInputProps }) => (
                                    <div {...getRootProps()} style={{ border: '1.5px dashed #d1d5db', padding: '24px', cursor: 'pointer', marginTop: '8px' }}>
                                        <input {...getInputProps()} />
                                        <p style={{ margin: 0, textAlign: 'center', color: '#9ca3af', fontSize: '0.85rem' }}>
                                            Arrastrá tu archivo acá o hacé clic para subirlo. Tamaño máximo 5MB
                                        </p>
                                    </div>
                                )}
                            </Dropzone>
                            {fileName && (
                                <p style={{ marginTop: '8px', fontSize: '0.82rem', color: '#7b2ff7' }}>
                                    ✓ {fileName}
                                </p>
                            )}
                        </div>

                        {/* Checkbox */}
                        <div className="wpp8m-checkbox-group form-group">
                            <input type="checkbox" className="custom-checkbox" id="terms" name="terms" required />
                            <label htmlFor="terms">Acepto los términos y condiciones</label>
                            <Link to="/terminos" className="btn btn-link">— Leer términos</Link>
                        </div>

                        {/* Submit */}
                        <button
                            type="submit"
                            className="wpp8m-submit-btn"
                            disabled={isSubmitting}
                        >
                            {isSubmitting ? (
                                <span className="wpp8m-btn-loader">
                                    <span className="wpp8m-spinner"></span>
                                    Enviando...
                                </span>
                            ) : 'Enviar postulación'}
                        </button>

                    </form>
                </div>
            </main>

            {/* FOOTER */}
            <footer className="wpp8m-footer">
                <p>© 2026 WPP. Todos los derechos reservados.</p>
            </footer>

        </div>
    );
};

export default WPP8MPage;
